import React from "react"
import PropTypes from "prop-types"
class LoadingSpinner extends React.Component {
  render () {
    return (
      <React.Fragment>
        <img src="/assets/ajax-spinner.gif" className="ajax-spinner" alt="Loading Indicator"/>
      </React.Fragment>
    );
  }
}

export default LoadingSpinner
